export default "/images/1a49105b9d09c33474b6e14a315f1aa8.jpg";